import * as types from '../../constant/actionTypes';

export function authUser() {
  return {
    type: types.AUTH_USER,
  };
}



// WEBPACK FOOTER //
// ./src/scenes/Login/actions.js